// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"444":"416af507dd5ce282","457":"9db323391075f828"}[chunkId] + ".js";
};